import React, { useEffect } from 'react'
import { Button } from 'components/UIElements'
import { browserHistory } from 'utils/navigation'
import '../stylesheets/Instruments.scss'
import UploadSurveyInput from '../../Instrument/routes/UploadSurvey/components/UploadSurveyInput'
import '../../../../../../../stylesheets/Wizard.scss'
import useInstrumentUnificationFeature from 'utils/hooks/useInstrumentUnificationFeature'

const InstrumentWizard = ({
  fileName,
  hasClinro,
  hasDiary,
  onDiscardUpload,
  onSave,
  onSurveyUpload,
  params,
  studyLock,
  title,
  updateWizardTitle,
  uploadedSurvey,
  userId,
  study,
  isReadOnlyState,
  studyVersionID,
}) => {
  const { id: studyID } = study

  const { hasInstrumentUnification } = useInstrumentUnificationFeature({ study, userId })

  const sections = hasInstrumentUnification
    ? ['Add questions', 'Add properties', 'Send participant instrument', 'Analyze results']
    : ['Add questions', 'Add properties', 'Send survey', 'Analyze results']

  useEffect(() => {
    updateWizardTitle('')
  }, [])
  return (
    <div className='instrument-wizard page'>
      <div className='wizard'>
        <div className='survey section'>
          <h1>{hasInstrumentUnification ? 'Create your first participant instrument' : 'Create your first survey'}</h1>
          <p>
            {hasInstrumentUnification
              ? 'A fast and easy way to build a participant instrument.'
              : 'A fast and easy way to build a survey.'}
          </p>
          <div className='visual'>
            {sections.map((text, idx) => {
              return (
                <div className='box-section' key={`section_${text}`}>
                  <div className='circle'>{idx + 1}</div>
                  <h4>{text}</h4>
                </div>
              )
            })}
          </div>
          <input
            value={title}
            onChange={e => updateWizardTitle(e.target.value)}
            className='custom-input'
            id='instrument-name-input'
            placeholder='Name this Instrument'
            disabled={studyLock || isReadOnlyState}
          />
          {!isReadOnlyState ? (
            <>
              <div className='instrument-button-list'>
                <Button
                  grey={hasClinro ? true : undefined}
                  onClick={() =>
                    browserHistory.push(`/studies/${studyID}/${studyVersionID}/instruments/createinstrument`)
                  }
                  content='Create Participant Instrument'
                  id='create-participant-instrument'
                  disabled={studyLock}
                />
                {hasClinro && (
                  <Button
                    onClick={() =>
                      browserHistory.push(`/studies/${studyID}/${studyVersionID}/instruments/createclinro`)
                    }
                    content='Create Clinician Instrument'
                    id='create-clinician-instrument'
                    disabled={studyLock}
                  />
                )}
              </div>
            </>
          ) : null}
          <h2>OR</h2>
          <UploadSurveyInput
            onSurveyUpload={onSurveyUpload}
            fileName={fileName}
            onDiscardUpload={onDiscardUpload}
            params={params}
            disabled={studyLock || isReadOnlyState}
          />
          {!isReadOnlyState ? (
            <Button
              disabled={uploadedSurvey === null || studyLock}
              onClick={() => onSave('properties')}
              id='upload-button'
              content='Upload'
            />
          ) : null}
          {hasDiary && !hasInstrumentUnification && !isReadOnlyState && (
            <div className='diary section'>
              <h1>Create your first diary</h1>
              <Button
                onClick={() => browserHistory.push(`/studies/${studyID}/${studyVersionID}/instruments/creatediary`)}
                content='Create Diary'
                disabled={studyLock}
              />
            </div>
          )}
        </div>
        <div className='article section'>
          <h1>Create your first article</h1>
          <input
            value={title}
            onChange={e => updateWizardTitle(e.target.value)}
            className='custom-input'
            id='article-name-input'
            placeholder='Name this Instrument'
            disabled={studyLock || isReadOnlyState}
          />
          {!isReadOnlyState ? (
            <Button
              onClick={() => browserHistory.push(`/studies/${studyID}/${studyVersionID}/instruments/createarticle`)}
              content='Create Article'
              id='create-article'
              disabled={studyLock}
            />
          ) : null}
        </div>
        <div className='task section'>
          <h1>Create your first task</h1>

          <Button
            id='proceed-to-task-library'
            onClick={() => browserHistory.push(`/studies/${studyID}/${studyVersionID}/instruments/selecttask`)}
            content='Proceed to Task Library'
            disabled={studyLock || isReadOnlyState}
          />
        </div>
      </div>
    </div>
  )
}

export default InstrumentWizard
